import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import IntroSection from "@/pages/home/components/IntroSection";
import SubtitleCard from "@/components/base/SubtitleCard";
import SectionHeading from "@/components/base/SectionHeading";
import { allSubtitles, sortSubtitles } from "@/utils/subtitles";

export default function Home() {
  const featured = allSubtitles.filter((item) => item.featured);
  const latest = sortSubtitles(allSubtitles, "latest").slice(0, 8);
  const hot = sortSubtitles(allSubtitles, "hot").slice(0, 8);

  return (
    <div>
      <HeroCarousel items={featured} />
      <CategoryQuickLinks />

      <section className="mx-auto w-full max-w-7xl px-4 pb-12 md:px-6 md:pb-14">
        <SectionHeading
          title="最新发布字幕"
          subtitle="按更新时间排序，每日同步最新字幕资源"
          icon="ri-time-line"
          action={
            <Link
              to="/search"
              className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              查看更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        {latest.length > 0 ? (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {latest.map((item) => (
              <SubtitleCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 py-16 text-center">
            <i className="ri-inbox-line text-4xl text-background-500"></i>
            <p className="mt-3 text-sm text-foreground-500">暂无最新资源，敬请期待</p>
          </div>
        )}
      </section>

      <section className="bg-background-100 py-12 md:py-14">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
          <SectionHeading
            title="热门推荐字幕"
            subtitle="按下载量与评分精选，影迷最常下载的字幕合集"
            icon="ri-fire-line"
            action={
              <Link
                to="/category/movie"
                className="flex items-center gap-1 whitespace-nowrap rounded-md bg-accent-500 px-3 py-2 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-600"
              >
                热门电影字幕
                <i className="ri-arrow-right-line"></i>
              </Link>
            }
          />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {hot.map((item) => (
              <SubtitleCard key={item.id} item={item} />
            ))}
          </div>
        </div>
      </section>

      <IntroSection />
    </div>
  );
}